import { Wrapper } from "./styled";

export const SectionBanner = ({body}) => (
    <Wrapper>
        {body}
    </Wrapper>
);